namespace RedBullMOBILE360.Web.Modules.Common {
    export enum ReportChannel {
        Email = 0,
        SMS = 1
    }
    Serenity.Decorators.registerEnumType(ReportChannel, 'RedBullMOBILE360.Web.Modules.Common.ReportChannel', 'Reports.Channel');
}
